import { useState } from "react";
import ScrollReveal from "../Hooks/ScrollReveal";
import trophyICON from '../../assets/img/trophy.png';


const ProjectCard = ({ title, tags, github, website, images, modalToggle, hackathon }) => {
    const [hover, setHover] = useState(false);
    const toggleHover = () => {
        if (!images.hoverCover) return;
        return setHover(!hover);
    };

    return (
        <ScrollReveal>
            <div className="mb-8 sm:max-w-md "
                onMouseEnter={toggleHover}
                onMouseLeave={toggleHover}
                onTouchStart={toggleHover}
                onTouchEnd={toggleHover}
            >
                <div className="aspect-video bg-img hover:cursor-pointer" onClick={modalToggle}>
                    { hackathon && <div className="absolute pl-2 pt-2"><img src={trophyICON} className="h-4 mr-2 " alt="" /></div>}
                    <div className="zoom-img">
                        <img className={hover ? "hidden" : ""} src={images.cover} loading="lazy" alt="" />
                        {images.hoverCover && <img className={!hover ? "hidden " : ""} src={images.hoverCover} alt="" />}
                    </div>
                </div>
                <div>
                    <h1 className="font-openSans font-semibold uppercase text-xl  my-2">{title}</h1>
                    <div className="flex justify-between items-center">
                        <h1 className="font-notoSans uppercase  text-gray-700 font-6rem ">{tags}</h1>
                        <div className="ml-4 uppercase font-openSans font-semibold text-xs">
                            <a href={github} target={github == "#0" ? `_self` : '_blank'} className="py-0.5 px-3 bg-black text-white " >Github</a>
                            {website && tags.toLowerCase().includes("game") ?
                                <a href={website} target={website == "#0" ? `_self` : '_blank'} className="ml-2 py-0.5 px-3 bg-green-500 text-white hover:bg-green-600" >Play</a>
                                :
                                <a href={website} target={website == "#0" ? `_self` : '_blank'} className="ml-2 py-0.5 px-3 bg-sky-600 text-white hover:bg-sky-700" >website</a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </ScrollReveal>
    );
};

export default ProjectCard;